import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IconView, MenuItem } from '@gem/ui-kit';

import useSharedDataItems from 'APP/main/Profile/hooks/sharedDataItems';
import { Media } from 'APP/main/SharedData/Media/Media';

import { IProfileViewActions } from '../Profile.types';
import styles from './SavedMessagesProfile.styles.m.css';

interface ISavedMessagesProfileProps {
  className: string;
  groupId: string;
  actions: IProfileViewActions;
}

export const SavedMessagesProfile: FC<ISavedMessagesProfileProps> = observer(
  ({ className, groupId, actions }) => {
    const childPagesList = useSharedDataItems({ groupId, actions });

    return (
      <div className={className}>
        {childPagesList.items.map(({ key, title, Icon, onClick, count }) => (
          <MenuItem
            className={styles.listItem}
            key={key}
            title={title}
            count={count}
            icon={
              <IconView
                Icon={Icon}
                className={styles.listIcon}
              />
            }
            onClick={onClick}
          />
        ))}
        {childPagesList.items.length > 0 && <hr className={styles.dividerBackground} />}
        <Media
          // TODO: remove after rewrite to ts
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          groupId={groupId}
        />
      </div>
    );
  }
);
